/* eslint-disable @typescript-eslint/no-explicit-any */
// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

const MemberSnapshotRibbon = dynamic(() => import('./MemberSnapshotRibbon').then(mod => mod.MemberSnapshotRibbon));

export const MemberSnapshotRibbonConfig = {
  emptyLabel: 'MemberSnapshotRibbon',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/membersnapshotribbon`,
};

export const MemberSnapshotRibbonEditable = (props: any) => (
  <EditableComponent config={MemberSnapshotRibbonConfig} {...props}>
    <MemberSnapshotRibbon {...props} />
  </EditableComponent>
);
